export default __webpack_public_path__ + "static/media/img_1.81b12157.JPG";